import { API_BASE, INO_API_BASE, NEXT_API_BASE } from '@/Module/Core/Constant';

export const AUTH_API = {
  // New INO APIs
  SEND_OTP_CODE: `${INO_API_BASE}/accounts/auth/login-otp`,
  LOGIN_VERIFY_OTP_CODE: `${INO_API_BASE}/accounts/auth/login-otp/verify`,
  // Old APIs
  GET_MY_PERSON: `${API_BASE}/Person/GetByUser`,
  UPDATE_MY_PERSON: `${API_BASE}/Person/UpdateRegistrationInfo`,
  GET_CATEGORY_BY_GRADE_ID: `${API_BASE}/CategoryCategory/GetByChildId`,
  EXAM_REGISTER_OR_LOGIN: `${API_BASE}/exam-builder/auth/token`,
  GET_STATES: `${API_BASE}/locations/states`,
  GET_CITIES: `${API_BASE}/locations/cities`,
  GET_REFER_TYPES: `${API_BASE}/user-refer-types/valid-items`,
  PUT_REFER_TYPE: `${API_BASE}/person/ueser-refer-type`,
  POST_FREE_TRIAL: `${API_BASE}/Subscription/api/subscriptions/use-free-trial`,
  GET_STATISTICS: `${API_BASE}/lessons/current-user/statistics/view-count-duration`,
  // Rubika
  RUBIKA: `${NEXT_API_BASE}/rubika/link`,
  CHECK_RUBIKA_TOKEN: `${API_BASE}/rubika/users/auth/signin`,
  LINK_RUBIKA_USER: `${API_BASE}/rubika/users/complete-info`,
  // Shad
  CHECK_SHAD_TOKEN: `${API_BASE}/shad/users/auth/signin`,
};
